import { Components, Theme } from '@mui/material';

import { formControlStyles } from './MuiFormControl';

export const MuiPickersInputBase: Components<Theme>['MuiPickersInputBase'] = {
  styleOverrides: {
    root: {
      ...formControlStyles,
      fontSize: '16px !important',
    },
  },
};
